import ResetApi from "../reset_connection";
const resource_api_path = "/blogs";

export default {
    index(query, page, filter, sort_by) {
      return ResetApi.get(`${resource_api_path}`, { params: { q: query, page: page, filter: filter, sort_by: sort_by}});
    },
    all(query, page, filter) {
      return ResetApi.get(`${resource_api_path}/all`, { params: { q: query, page: page, filter: filter}});
    },
    create(payload) {
      return ResetApi.post(resource_api_path, { payload });
    },
    show(id) {
      return ResetApi.get(`${resource_api_path}/${id}`);
    },
    update(id, payload) {
      return ResetApi.patch(`${resource_api_path}/${id}`, { payload });
    },
    destroy(id) {
      return ResetApi.delete(`${resource_api_path}/${id}`);
    },
    fetch_authors(page) {
      return ResetApi.get(`${resource_api_path}/fetch_authors`, { params: { page: page}});
    },
    fetch_primary_buckets(page) {
      return ResetApi.get(`${resource_api_path}/fetch_primary_buckets`, { params: { page: page}});
    },

    fetch_secondary_buckets(page, primary_bucket_id) {
      return ResetApi.get(`${resource_api_path}/fetch_secondary_buckets`, { params: { page: page, primary_bucket_id: primary_bucket_id}});
    },

    fetch_ternary_buckets(page, ids) {
      return ResetApi.get(`${resource_api_path}/fetch_ternary_buckets`, { params: { page: page, secondary_bucket_ids: ids}});
    },

    publish_for_review(id){
      return ResetApi.post(`${resource_api_path}/${id}/publish_for_review`);
    },

    save_publish_for_review(payload){
      return ResetApi.post(`${resource_api_path}/save_publish_for_review`, { payload });
    },

    approve_blog(id){
      return ResetApi.post(`${resource_api_path}/${id}/approve_blog`);
    },

    reject_blog(id){
      return ResetApi.post(`${resource_api_path}/${id}/reject_blog`);
    },

    delete_multiple_blogs(payload) {
      return ResetApi.post(`${resource_api_path}/delete_multiple_blogs`, { payload });
    },

    approve_multiple_blogs(payload) {
      return ResetApi.post(`${resource_api_path}/approve_multiple_blogs`, { payload });
    },

    reject_multiple_blogs(payload) {
      return ResetApi.post(`${resource_api_path}/reject_multiple_blogs`, { payload });
    },
}